import { Injectable } from "@angular/core";
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { BaseGridResponse } from "../../../data/shared/base-grid.response";
import { GetMasterPlanLocationsRequest, MasterPlanLocation } from "../../domain";
import { MasterPlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetPlanContainerLocationUseCase implements UseCase<BaseRequest<GetMasterPlanLocationsRequest>, BaseGridResponse<MasterPlanLocation>>{
    
    constructor(private readonly masterPlanRepository: MasterPlansRepository){
    }

    execute(param: BaseRequest<GetMasterPlanLocationsRequest>): Observable<BaseGridResponse<MasterPlanLocation>>{
        return this.masterPlanRepository.getPlanContainerLocations(param);
    }
}